import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { SubscriptionStatusSwitchIcon } from '@/epics/subscriptionManagment/pages/subscriptionList/SubscriptionStatusDialogContent';

export type OfferStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getOfferStatusDialogConfig(
  offerName: string,
  isActive: boolean
): OfferStatusDialogConfig {
  const isActivating = !isActive;
  return {
    title: isActivating ? 'Aktywować ofertę?' : 'Dezaktywować ofertę?',
    content: (
      <>
        {isActivating ? (
          <>
            Czy na pewno chcesz aktywować ofertę{' '}
            <span className="font-medium">{offerName}</span>?
          </>
        ) : (
          <>
            Czy na pewno chcesz dezaktywować ofertę{' '}
            <span className="font-medium">{offerName}</span>?
          </>
        )}
      </>
    ),
    confirmButtonLabel: isActivating ? 'Aktywuj' : 'Dezaktywuj',
    confirmButtonLabelLoading: isActivating
      ? 'Aktywowanie…'
      : 'Dezaktywowanie…',
    icon: <SubscriptionStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
